module.exports = __webpack_public_path__ + "img/resources.48a9accf.svg";